<app-modal [title]="'Verify your phone number' | translate">

  <div ngbAutoFocus class="modal-content  pt-0" style="overflow: visible;">

    <app-otp (submit)="activeModal.close($event)" [phoneNumber]="phoneNumber" [otpConfirmed]="false"
      [endButtonText]="'Make a new request' | translate">
      <span style="font-size: 80px;" class="material-symbols-rounded text-success mb-3">check_circle</span>
      <p>
        {{ 'Request sent successfully. You will receive an SMS with a link.' | translate }}
        <br>
        {{ 'Click it to access.' | translate }}
      </p>
    </app-otp>
  </div>
</app-modal>